import { createContext, useContext } from 'react'

type PopoverOverlayContextValue = {
  /**
   * When true, force `<PopoverOverlay/>` to render the desktop-style
   * anchored `<PropertyPopover/>` even on mobile breakpoints — bypassing
   * the default behavior of switching to a bottom-sheet `<Overlay/>`.
   *
   * Use case: inline chip strips where the trigger lives at the bottom of
   * a sheet/dialog and the bottom-sheet popover would be visually
   * disconnected from the trigger. Anchored popovers open right above the
   * chip and read as "this control opened that menu". The mobile New
   * Issue dialog's chip strip is the canonical example — its triggers sit
   * just above the soft keyboard, and a screen-bottom drawer slides up
   * over both the dialog and the keyboard with no visible link to the
   * chip that was tapped.
   *
   * Defaults to `false`. Existing call sites are unaffected unless a
   * `<PopoverOverlayContext.Provider value={{ forceAnchored: true }}/>`
   * is mounted above them.
   */
  forceAnchored?: boolean
}

const PopoverOverlayContext = createContext<PopoverOverlayContextValue>({})

export const PopoverOverlayProvider = PopoverOverlayContext.Provider
export const usePopoverOverlayContext = () => useContext(PopoverOverlayContext)
